import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Card, Descriptions, Layout, Row, Col, Table, Input, Space, Button, Tag } from 'antd'
import { FilePdfOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import { DefaultLayout } from 'src/layouts/default'
import { Gap } from 'src/components/atoms/Gap'

export const _PreviewCouponAll = ({ loading, meta, data, token, dispatch }) => {
  const { state } = useLocation()

  console.log(state)

  useEffect(() => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_all',
      payload: {
        token,
        params: { couponId: state?.id }
      }
    })
  }, [])

  const onHandleSearch = (e) => {
    const { target } = e

    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_all',
      payload: { token, params: { q: target.value, couponId: state?.id } }
    })
  }

  const onHandlePaginate = (page, pageSize) => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_all',
      payload: { token, params: { page: page, couponId: state?.id } }
    })
  }

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      align: 'center',
      width: 20,
      render: (text, obj, index) => <a>{index + 1}</a>
    },
    {
      title: 'Unique Code',
      dataIndex: 'trackId',
      align: 'center',
      render: (text, obj) => <a>{obj.trackId}</a>
    },
    {
      title: 'Name',
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      align: 'center'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      align: 'center',
      render: (email) => <>{email ?? '-'}</>
    },
    {
      title: 'Entered At',
      dataIndex: 'createdAt',
      align: 'center',
      render: (date) => <>{moment(date).format('DD-MM-YYYY, HH:mm')} WIB</>
    },
    {
      title: 'Used',
      dataIndex: 'isUsed',
      align: 'center',
      render: (txt) => <>{txt ? 'Dipakai' : 'Belum Dipakai'}</>
    },
    {
      title: 'Batch No',
      dataIndex: 'customCode',
      align: 'center',
      render: (txt) => <>{txt || '-'}</>
    }
  ]

  return (
    <DefaultLayout>
      <Layout.Content className='container-detail-product'>
        <Card>
          <Row>
            <Col span={16}>
              <Descriptions title='Detail Coupon (all-data)'>
                <Descriptions.Item label='Coupon'>
                  {state.coupon}
                </Descriptions.Item>
                <Descriptions.Item label='Claim Limit Per User Phone'>
                  {state.limitClaim ? state.limitClaim : 'Unlimited'}
                </Descriptions.Item>
                <Descriptions.Item label='Claim Limit Per QR'>
                  {state.limitClaimPerQr ? state.limitClaimPerQr : 'Unlimited'}
                </Descriptions.Item>
                <Descriptions.Item label='Periode'>
                  {moment(state.startDate).format('L')} -{' '}
                  {moment(state.endDate).format('L')}
                </Descriptions.Item>
                <Descriptions.Item label='Discount (%)'>
                  {state.discountCalculated.percentage}%
                </Descriptions.Item>
                <Descriptions.Item label='Discount (Rp)'>
                  Rp{' '}
                  {Intl.NumberFormat('id').format(
                    state.discountCalculated.priceDiscounted
                  )}
                </Descriptions.Item>
                <Descriptions.Item label='Redirect Type'>
                  {state.redirect === 'default' && 'Opim Default'}
                  {state.redirect === 'custom' && 'Custom Page'}
                  {state.redirect === 'noredirect' && 'No Redirect'}
                </Descriptions.Item>
                <Descriptions.Item label='PDF Ebook'>
                  {state.downloadPdfEbook
                    ? (
                      <Space>
                        <Tag color='success' icon={<CheckCircleOutlined />}>
                          Available
                        </Tag>
                        <Button
                          type='link'
                          size='small'
                          icon={<FilePdfOutlined />}
                          href={state.downloadPdfEbook}
                          target='_blank'
                        >
                          Download
                        </Button>
                      </Space>
                      )
                    : (
                      <Tag color='default' icon={<CloseCircleOutlined />}>
                        Not Available
                      </Tag>
                      )}
                </Descriptions.Item>
                <Descriptions.Item label='Send WA Notif'>
                  {state.sendWaNotif ? 'Yes' : 'No!'}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={8}>
              <Input
                allowClear
                onChange={debounce(onHandleSearch, 500)}
                placeholder='Search'
              />
            </Col>
          </Row>
          <Gap height='1rem' />
          <Table
            rowKey='id'
            columns={columns}
            dataSource={data ?? []}
            rowSelection={{
              type: 'checkbox'
            }}
            loading={loading}
            scroll={{ x: 'max-content' }}
            pagination={
              meta && {
                defaultPageSize: meta.itemsPerPage,
                total: meta.totalItems,
                pageSize: meta.itemsPerPage,
                onChange: (page, pageSize) => onHandlePaginate(page, pageSize)
              }
            }
          />
        </Card>
      </Layout.Content>
    </DefaultLayout>
  )
}

const mapStateToProps = ({ reducerCouponClaimers }) => {
  return { ...reducerCouponClaimers }
}

export const PreviewCouponAll = connect(mapStateToProps)(_PreviewCouponAll)

_PreviewCouponAll.propTypes = {
  dispatch: PropTypes.func,
  token: PropTypes.string,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array])
}
